module.exports = __webpack_public_path__ + "img/st1.2ae6e0da.png";